// apply a static nonlinear function on a signal x (array)
export function fnc(u, U0) {
  const u0 = 2;
  u = u0 * u;
  return (2 * U0 * u + u * u) / (2 * U0 * u0 + u0 * u0);
  // (x + (x * x - 0.5) / (2 * U0 + 0.5)) / 2;
}
